import { render } from "./LimitModal.vue?vue&type=template&id=ce3863f0"
import script from "./LimitModal.vue?vue&type=script&lang=js"
export * from "./LimitModal.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__